/** `POST fee/portal/access-status` result. */
export type PortalAccessStatus = {
  blocked: boolean
  /** Why the portal is locked (PHP /site/defaulteraccessdisable, with or without `fee=false`). */
  reason: 'fee_defaulter' | 'restricted_login' | null
  /** The school's message (fee settings / general settings); may be empty. */
  message: string | null
  studentUserId?: number | null
}

export const OPEN_ACCESS: PortalAccessStatus = {blocked: false, reason: null, message: null}

/**
 * Routes a locked family can still open — PHP `processDisableDefaulterAccess`
 * lets `finance/finance/view` (the fee voucher), `site/logout` and
 * `site/changeStudent` through. The child switcher lives in the header, which
 * the lock never covers.
 */
const ALLOWED_PREFIXES = ['/fee/vouchers', '/finance/finance/view', '/fee', '/logout']

/**
 * Whether the path stays reachable while the portal is locked. The fee pages
 * are only let through for a fee-defaulter lock (PHP shows the "Fee Voucher"
 * button only then).
 */
export const isPathAllowedWhileLocked = (pathname: string, status: PortalAccessStatus) => {
  const path = pathname.replace(/\/+$/, '') || '/'
  if (path === '/logout' || path.startsWith('/logout/')) return true
  if (status.reason !== 'fee_defaulter') return false
  return ALLOWED_PREFIXES.some(
    (prefix) => prefix !== '/logout' && (path === prefix || path.startsWith(`${prefix}/`))
  )
}
